/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { Tabs, Tab } from "@mui/material";
import { GridViewOutlined as GridViewOutlinedIcon } from "@mui/icons-material";
import { FileUpload as FileUploadIcon } from "@mui/icons-material";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import { MODES } from "cms/images/image-selector/image-selector-config";
import { Logger } from "cms/utils/log/logger";

const ImageDialogTopActions = () => {

    const imageEditContext = useContext(ImageEditContext);
    const setMode = imageEditContext?.setMode;
    const selectedTab = imageEditContext?.selectedTab;
    const setSelectedTab = imageEditContext?.setSelectedTab;

    const handleTabsChange = (event, newValue) => {
        switch (newValue) {
            case 0:
                setMode(MODES.SELECT);
                setSelectedTab(newValue);
                Logger.debug(MODES.SELECT);
                break;
            case 1:
                setMode(MODES.UPLOAD);
                setSelectedTab(newValue);
                Logger.debug(MODES.UPLOAD);
                break;
            default:
                Logger.debug(`tab selected was not understood [${newValue}]`);
                break;
        }
    };
    return (
        <Fragment>
            <div className="simplicity-image-selector-window-tabs">
                <Tabs value={selectedTab} onChange={handleTabsChange} aria-label="edit tabs">
                    <Tab
                        label="Images"
                        icon={<GridViewOutlinedIcon />}
                        iconPosition="start"
                        color="primary"
                        id='tabpanel-1'
                        aria-controls='tabpanel-1'
                    />
                    <Tab
                        label="Upload"
                        icon={<FileUploadIcon />}
                        iconPosition="start"
                        id='tabpanel-2'
                        aria-controls='tabpanel-2'
                    />
                </Tabs>
            </div>
        </Fragment>
    );
};

export { ImageDialogTopActions };
